import {FormLocationCombo} from "snimf/location/components";

const PlotLocationFormFields = () => {
    return <FormLocationCombo orientation="row" required fullCombo />;
};

export default PlotLocationFormFields;
